import { render, staticRenderFns } from "./notificationPopup.vue?vue&type=template&id=6491505f&"
import script from "./notificationPopup.vue?vue&type=script&lang=js&"
export * from "./notificationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports